import { createFrontendPlugin, PageBlueprint } from '@backstage/frontend-plugin-api';
import TimelineIcon from '@material-ui/icons/Timeline';

// No `name`. A named extension becomes `page:liveness/liveness`, a SUB-page, and
// only a plugin's default page (`page:liveness`) is given a sidebar entry - so the
// route worked and nothing linked to it, which is the same as not shipping it.
const livenessPage = PageBlueprint.make({
  params: {
    path: '/liveness',
    title: 'Liveness',
    icon: <TimelineIcon />,
    loader: () =>
      import('./LivenessPage').then(m => <m.LivenessPage />),
  },
});

// A PLUGIN, not a module. createFrontendModule attaches extensions to a plugin
// that already exists (the way modules/home extends plugin-home); pointed at a
// pluginId nobody registers, it is silently ignored and the route 404s with no
// error anywhere. A page that belongs to nothing has to bring its own plugin.
export const livenessModule = createFrontendPlugin({
  pluginId: 'liveness',
  extensions: [livenessPage],
});
